import { shouldShowForkedFrom } from "./shouldShowForkedFrom";

import {
  getVersionAuthor,
  getVersionCommitMessage,
  getVersionLabels,
  getVersionReportId,
  VersionSelectorVersion,
} from "@/components/VersionSelector/types";

const useVersionDetails = (version: VersionSelectorVersion) => {
  const reportId = getVersionReportId(version);
  const parentVersionNumber = version.parent_version?.number ?? null;

  return {
    id: version.id,
    created_at: version.created_at,
    commit_message: getVersionCommitMessage(version),
    number: version.number,
    labels: getVersionLabels(version),
    author: getVersionAuthor(version) ?? undefined,
    hasReportId: Boolean(reportId),
    reportId,
    archived: version.archived,
    parentVersionNumber: shouldShowForkedFrom(version.number, parentVersionNumber)
      ? parentVersionNumber
      : null,
  };
};

export default useVersionDetails;
